import { ArrowUp } from "lucide-react"
import React, { useState, useEffect } from "react"

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            setIsVisible(window.pageYOffset > 100)
        }

        window.addEventListener("scroll", handleScroll)

        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, [])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        })
    }

    const buttonClass = `fixed text-sm bottom-2 right-2 z-40 p-2 bg-white opacity-100 text-maroon border-2 border-[#B4530A] rounded cursor-pointer flex items-center gap-2 font-semibold`

    return (
        isVisible && (
            <button
                onClick={scrollToTop}
                className={buttonClass}
                aria-label="Scroll to top"
            >
                <ArrowUp className="w-5 h-5" />
            </button>
        )
    )
}

export default ScrollToTopButton
